/// <amd-module name="SuiteCommerce.LookBook.Look.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.LookBook.Look.Model", ["require", "exports", "Backbone", "SuiteCommerce.LookBook.Common.Utils", "SuiteCommerce.LookBook.LookItem.Collection"], function (require, exports, Backbone_1, Utils_1, LookItem_Collection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LookModel = void 0;
    var LookModel = /** @class */ (function (_super) {
        __extends(LookModel, _super);
        function LookModel() {
            var _this = _super.call(this) || this;
            _this.urlRoot = Utils_1.Utils.getAbsoluteUrl(getExtensionAssetsPath('services/Look.Service.ss'));
            _this.setupListeners();
            return _this;
        }
        LookModel.prototype.setupListeners = function () {
            this.on('change:items', function (model, items) {
                if (!(items instanceof LookItem_Collection_1.LookItemCollection)) {
                    model.set('items', new LookItem_Collection_1.LookItemCollection(items, { parse: true }));
                }
            });
        };
        LookModel.prototype.getName = function () {
            return this.get('name');
        };
        LookModel.prototype.getMetaDescription = function () {
            return this.get('metadesc') || this.get('longdesc');
        };
        LookModel.prototype.getMetaKeywords = function () {
            return this.get('metakeys') || this.get('name');
        };
        LookModel.prototype.getTitle = function () {
            return this.get('title') || this.get('name');
        };
        LookModel.prototype.getLookbok = function () {
            return this.get('lookbook');
        };
        LookModel.prototype.getLookBookUrlComponent = function () {
            return this.get('lookbookUrlcomponent');
        };
        LookModel.prototype.getUrlComponent = function () {
            return this.get('urlcomponent');
        };
        LookModel.prototype.getItems = function () {
            return this.get('items');
        };
        LookModel.prototype.getSequence = function () {
            return this.get('sequence');
        };
        LookModel.prototype.getShortDesc = function () {
            return this.get('shortdesc');
        };
        LookModel.prototype.getLongDesc = function () {
            return this.get('longdesc');
        };
        LookModel.prototype.getMainImage = function () {
            return this.get('image2');
        };
        LookModel.prototype.getAltImage = function () {
            return this.get('image3');
        };
        return LookModel;
    }(Backbone_1.Model));
    exports.LookModel = LookModel;
});
